import { FC } from 'react';

import classNames from 'classnames';

import Flex from '../../Flex.tsx';
import BaseHeader from '../../../headers/core/BaseHeader.tsx';
import SecondaryText from '../../../typography/SecondaryText.tsx';
import Routes from '../../../../router/routes.enum.ts';

const Header: FC = () => {
  const path = window.location.pathname;
  const isAdmin = path.includes(Routes.AdminSignIn);

  return (
    <BaseHeader className={classNames('absolute top-0 left-0 right-0 w-full')}>
      <Flex.Wrapper jStart className="flex-1 items-center">
        <div className="mx-[24px] w-[1px] bg-gray-400 h-[30px]" />

        <SecondaryText className="text-gray-200 whitespace-nowrap">
          {isAdmin ? 'For Admin' : 'For Company'}
        </SecondaryText>
      </Flex.Wrapper>
    </BaseHeader>
  );
};

export default Header;
